// extracted by mini-css-extract-plugin
export default {"row":"GVzzzKDV","title":"-VqFXWt-"};